export default "/images/icon_key_secondary.svg?3a5ae0bc4cc6ee137458ab129e4a1686";